import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { BookingSummaryResult } from 'models/booking';
import { CancelVerificationModalData } from 'models/cancel-verification-modal-data';

@Component({
	selector: 'app-cancel-verification-modal',
	template: require('./cancel-verification-modal.component.html'),
})
export class CancelVerificationModal {
	@Output() cancel: EventEmitter<BookingSummaryResult | null> = new EventEmitter<BookingSummaryResult | null>();
	@Output() close = new EventEmitter();
	@Input() data: CancelVerificationModalData | null = null;
}
